var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){_vm.loading=$event}}}),(!_vm.loading)?_c('div',[_c('Questions')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }